import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const ExchangeRateResponseSchema = z.object({
  rate: z.number().positive(),
  currency: z.string().min(1),
});

export type ExchangeRateResponse = z.infer<typeof ExchangeRateResponseSchema>;

export const exchangeRateContract = c.router({
  getRate: {
    method: 'GET',
    path: '/external-api/get-rate/:currency',
    pathParams: z.object({
      currency: z.string(),
    }),
    responses: {
      200: ExchangeRateResponseSchema,
      400: z.object({ message: z.string() }),
    },
  },
});
